<script setup lang="ts">
import { NavigationMenuRoot, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "reka-ui";

const { siteOptions } = useSiteOptions();
</script>

<template>
  <NavigationMenuRoot v-if="siteOptions" id="menu-footer" orientation="vertical">
    <NavigationMenuList orientation="vertical" class="space-y-2 text-xl font-semibold">
      <NavigationMenuItem v-for="item in siteOptions.footer_menu_items" :key="item.id" :class="item.class">
        <NavigationMenuLink :href="item.url" :target="item.target">
          {{ item.title }}
        </NavigationMenuLink>
      </NavigationMenuItem>
    </NavigationMenuList>
  </NavigationMenuRoot>
</template>
